import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { optionalSession } from "@/app/optional-session"
import { PortalAuthPanel } from "@/components/layout/portal-auth-panel"
import { PortalSignInForm } from "@/features/auth/components/portal-sign-in-form"

const searchSchema = z.object({
  email: z.string().optional(),
  redirect: z.string().optional(),
  challenge: z.string().optional(),
})

export const Route = createFileRoute("/$organisation/portal/login/")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, params }) => {
    if (await optionalSession(context.queryClient)) {
      throw redirect({
        to: "/$organisation/portal",
        params: { organisation: params.organisation },
      })
    }
  },
  component: PortalLoginPage,
})

function PortalLoginPage() {
  const { brand } = Route.useRouteContext()
  const { email, redirect, challenge } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <PortalAuthPanel brand={brand}>
      <PortalSignInForm
        email={email}
        challenge={challenge}
        redirectTo={redirect ?? "/$organisation/portal"}
        onChallenge={(next, to) =>
          void navigate({
            search: (search) => ({ ...search, email: to, challenge: next }),
            replace: true,
          })
        }
      />
    </PortalAuthPanel>
  )
}
